module.exports = __webpack_public_path__ + "static/media/styleme.48a17be0.png";